export enum LayoutMode {
  CATALOG = 'CATALOG',
  DEFAULT = 'DEFAULT',
}
export type LayoutState = { isNotPremiumModalOpen: boolean; layoutMode: LayoutMode };
